export interface LogScreen {
    id: string;
    label: string;
}

export const isLogScreen = (item: LogScreen | any): item is LogScreen => {
    return (item as LogScreen).id !== undefined && (item as LogScreen).label !== undefined;
};
